import { useEffect, useState } from "react";
import { NAV } from "../../lib/siteData";
import { scrollToId } from "./SmoothScroll";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-es-bg/80 backdrop-blur-xl border-b border-es-border"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => scrollToId("top")}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif text-2xl tracking-tight text-es-fg">EverSoul</span>
          <span className="text-[10px] uppercase tracking-[0.35em] text-es-muted-fg mt-1 hidden sm:block">
            world
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <button
              key={item.id}
              data-testid={`nav-${item.id}`}
              onClick={() => scrollToId(item.id)}
              className="text-[13px] tracking-wide text-es-muted-fg hover:text-es-fg transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
          <a
            href="/how-it-works"
            data-testid="nav-how-it-works"
            className="text-[13px] tracking-wide text-es-muted-fg hover:text-es-fg transition-colors duration-300"
          >
            How It Works
          </a>
          <a
            href="/legacy-intelligence-index"
            data-testid="nav-legacy-index"
            className="text-[13px] tracking-wide text-es-muted-fg hover:text-es-fg transition-colors duration-300"
          >
            Legacy Index
          </a>
        </nav>

        <button
          data-testid="header-cta"
          onClick={() => scrollToId("invest")}
          className="group relative text-[13px] tracking-wide px-5 py-2.5 rounded-full border border-es-fg text-es-fg overflow-hidden"
        >
          <span className="relative z-10 transition-colors duration-400 group-hover:text-es-primary-fg">
            Partner &amp; Invest
          </span>
          <span className="absolute inset-0 bg-es-fg scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-400 ease-[cubic-bezier(0.25,1,0.5,1)]" />
        </button>
      </div>
    </header>
  );
};
